var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button",on:{"click":_vm.clickHandler}},[_c('Icon',{staticClass:"back-button__icon",attrs:{"name":"arrowUp","size":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }